module.exports = __webpack_public_path__ + "img/planet-earth.c54ed850.svg";